import React from "react";

const UploadedAttachment = ({ attachments, setAttachments }) => {

  // Handle delete
  const handleRemove = (indexToRemove) => {
    const newAttachments = [...attachments];
    newAttachments.splice(indexToRemove, 1);
    setAttachments(newAttachments);
  };

  return (
    <div className="fileDisplay">
      {attachments.map((file, index) => {
        const fileType = file.name.split(".").pop().toUpperCase();
        const fileSize = `${(file.size / 1024).toFixed(2)} KB`;

        const isImage =
          file.name.endsWith(".png") ||
          file.name.endsWith(".jpg") ||
          file.name.endsWith(".jpeg") ||
          file.name.endsWith(".gif");

        return (
          <div className="file-card mb-3" key={index}>
            <div className="file-info">
              <img
                src={isImage ? URL.createObjectURL(file) : "/assets/images/file-icon.svg"}
                className="file-icon"
                alt="File"
                style={{
                  width: "30px",
                  height: "30px",
                  objectFit: "cover",
                  borderRadius: "4px",
                }}
              />
              <div className="file-name">
                <h6>{file.name}</h6>
                <p>
                  {fileType} • {fileSize}
                </p>
              </div>
            </div>
            <button className="remove-btn" onClick={() => handleRemove(index)}>
              <img src="/assets/images/cross-icon.svg" alt="Remove" />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default UploadedAttachment;
